<template>
  <Baseline>
    <template #content>
      <router-view />
    </template>
  </Baseline>
</template>
  
<script>
import Baseline from '@/components/baseline';

export default{

  components:{
    Baseline
  }
}
</script>